export class ChartMapOptions
{
    public static id = 'map';
    public static fill = false;

    public static getOptions() : any {

        return '';
    };

    public static getAdditionalData() : any{
        return '';
    }
}




// WEBPACK FOOTER //
// ./src/app/components/charts/chart/model/options-type/chart-map-options.ts